import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {RouterLink, RouterLinkActive} from '@angular/router';

@Component({
  selector: 'peps-button-simple',
	imports: [
		RouterLink,
		RouterLinkActive
	],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './button-simple.component.html',
})
export class ButtonSimpleComponent {

	constructor() {}

	@Input() text: string = '';
	@Input() route: string = '';

}
